import { Inventory2Outlined as PackageIcon } from '@mui/icons-material';
import { Popover } from '@mui/material';
import { useState } from 'react';

interface PackagesDetailBadgeProps {
  packagesCount: number;
  packagesPicked?: { departure: number; arrival: number };
}

const PackagesDetailBadge = ({
  packagesCount,
  packagesPicked,
}: PackagesDetailBadgeProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);

  return (
    <>
      <button
        type='button'
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        className='relative z-10 flex items-center gap-1 rounded bg-gray-100 px-2 py-1 flex-shrink-0 cursor-pointer hover:bg-gray-200 transition-colors'
        title='Ver detalle de bultos'
      >
        <PackageIcon sx={{ fontSize: 16 }} className='text-gray-500' />
        <span className='text-sm font-medium text-gray-600'>
          {packagesCount}
        </span>
      </button>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className='flex flex-col gap-2 p-3 min-w-[220px]'>
          <div className='text-sm font-semibold text-gray-800'>
            Bultos de esta visita: {packagesCount}
          </div>
          {packagesPicked != null ? (
            <div className='flex flex-col gap-1.5 text-sm text-gray-600'>
              <div>
                <span className='font-medium text-gray-800'>
                  Escaneados en la salida:
                </span>{' '}
                {packagesPicked.departure}/{packagesCount}
              </div>
              <div>
                <span className='font-medium text-gray-800'>
                  Escaneados en la entrega:
                </span>{' '}
                {packagesPicked.arrival}/{packagesCount}
              </div>
            </div>
          ) : (
            <div className='text-sm text-gray-500'>
              Sin datos de escaneo todavía.
            </div>
          )}
        </div>
      </Popover>
    </>
  );
};

export default PackagesDetailBadge;
